import { createContext, useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import React from "react";


const AuthContext = createContext();
export default AuthContext;
export const AuthProvider = ({ children }) => {
  let [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );
  let [user, setUser] = useState(() =>
    localStorage.getItem("authTokens")
      ? jwt_decode(localStorage.getItem("authTokens"))
      : null
  );
  let [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  // console.log(`${process.env.REACT_APP_URL}`);
  let loginUser = async (e) => {
    e.preventDefault();
    let response = await fetch(`${process.env.REACT_APP_URL}/api/token/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: e.target.username.value,
        password: e.target.password.value,
      }),
    });
    let data = await response.json();

    if (response.status === 200) {
      setAuthTokens(data);
      setUser(jwt_decode(data.access));
      localStorage.setItem("authTokens", JSON.stringify(data));
      navigate("/");
    } else {
      const errorMessages = Object.values(data).flatMap((errorArray) => errorArray);
      const errorMessageString = errorMessages.join('\n');
      alert(JSON.stringify(errorMessageString));
      navigate("/register")

    }
  };

  let registerUser = async (e) => {
    e.preventDefault();
    let response = await fetch(`${process.env.REACT_APP_URL}/api/register/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        first_name: e.target.firstname.value,
        email: e.target.username.value,
        password: e.target.password.value,
        password2: e.target.repassword.value,
      }),
      
    });
    
    let data = await response.json();
    if (response.status === 201) {
      alert("Account is created Successfully.")
      navigate("/signin");
    } else {
      // console.log(data)
      const errorMessages = Object.values(data).flatMap((errorArray) => errorArray);
      const errorMessageString = errorMessages.join('\n');
      alert(JSON.stringify(errorMessageString));
      navigate("/register")
    }
  };

  let logoutUser = () => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem("authTokens");
    navigate("/signin");
  };

  let updateToken = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/api/token/refresh/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        refresh: (authTokens && authTokens.refresh),
      }),
    });

    // console.log("Refresh Token:", authTokens && authTokens.refresh);

    let data = await response.json();

    if (response.status === 200) {
      setAuthTokens(data);
      setUser(jwt_decode(data.access));
      localStorage.setItem("authTokens", JSON.stringify(data));
    } else {
      logoutUser();
    }

    if (loading) {
      setLoading(false);
    }
  };

  let contextData = {
    user: user,
    authTokens: authTokens,
    loginUser: loginUser,
    logoutUser: logoutUser,
    registerUser: registerUser,
  };

  useEffect(() => {
    if (loading) {
      updateToken();
    }

    let fourMinutes = 1000 * 60 * 5;

    let interval = setInterval(() => {
      if (authTokens) {
        updateToken();
      }
    }, fourMinutes);
    return () => clearInterval(interval);
  }, [authTokens, loading]);

  return (
    <AuthContext.Provider value={contextData}>
      {loading ? null : children}
    </AuthContext.Provider>
  );
};
